import React, { useState, useEffect } from 'react';
import {
  Grid, Box, Typography, TextField, FormControl, InputLabel, Select, MenuItem,
  Button, Alert
} from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import axios from '../axiosInstance';
import eBrary_Logo from '../assets/eBrary_Logo.png';

const PasswordPage = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [profile, setProfile] = useState({
    password: '',
  });

  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setError("Session expired. Please log in again.");
        navigate('/LoginPage');
        return;
      }
  
      try {
        const res = await axios.get('https://backend.scholarkart.in/api/user/me', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setProfile(prev => ({ ...prev, ...res.data }));
      } catch (err) {
        if (err.response?.data?.msg?.includes('jwt expired')) {
          setError("Session expired. Redirecting to login...");
          localStorage.removeItem('token');
          setTimeout(() => navigate('/LoginPage'), 2000);
        } else {
          setError('Failed to load user profile.');
        }
      }
    };
  
    fetchUser();
  }, []);
  
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
  
    if (!currentPassword || !newPassword || !confirmPassword) {
      setMessage('Please fill in all fields.');
      return;
    }
  
    if (newPassword.length < 6) {
      setMessage('New password must be at least 6 characters long.');
      return;
    }
  
    if (newPassword !== confirmPassword) {
      setMessage('New password and confirm password do not match.');
      return;
    }
  
    try {
      await axios.post('https://backend.scholarkart.in/api/change-password', {
        currentPassword,
        newPassword
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
  
      setMessage('✅ Password updated successfully! Redirecting...');
      setTimeout(() => navigate('/mycourse'), 2000);
    } catch (err) {
      const msg = err.response?.data?.msg || 'Something went wrong. Try again.';
      setMessage(`❌ ${msg}`);
    }
  };
  

  return (
    <Grid container component="main" sx={{ height: '100vh' }}>
      {/* Left Panel */}
      <Grid item xs={12} md={6} sx={{ p: 6 }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Link to="/">
            <img src={eBrary_Logo} alt="eBrary Logo" style={{ height: 60 }} />
          </Link>
          <Typography component="h1" variant="h5" sx={{ fontWeight: 'bold', textAlign: 'center', textShadow: '1px 1px 3px rgba(0,0,0,0.3)' }}>
            Transformation of eBrary and eLearning experience.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h5" fontWeight="bold">Change Your Password</Typography>
          {error && <Alert severity="error">{error}</Alert>}
          {message && <Alert severity="info" sx={{ mt: 2 }}>{message}</Alert>}

          <Box component="form" onSubmit={handleChangePassword} mt={2}>

            <TextField
                label="Current Password"
                type="password"
                fullWidth
                margin="normal"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />

              <TextField
                label="New Password"
                type="password"
                fullWidth
                margin="normal"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />

              <TextField
                label="Confirm New Password"
                type="password"
                fullWidth
                margin="normal"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />

            <Button
              variant="contained"
              type="submit"
              disabled={
                !currentPassword || !newPassword || newPassword.length < 6 || newPassword !== confirmPassword
              }
              sx={{
                ml: 1,
                borderColor: 'rgb(11, 2, 114)',
                color: 'rgb(11, 2, 114)',
                fontWeight: 'bold'
              }}
            >
              Update Password
            </Button>


            <Box textAlign="center" mt={2}>
              <Typography variant="body2">
                No change?
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => navigate('/LoginPage')}
                  sx={{
                    ml: 1,
                    borderColor: 'rgb(11, 2, 114)',
                    color: 'rgb(11, 2, 114)',
                    fontWeight: 'bold'
                  }}
                >
                  Return to eBrary
                </Button>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Grid>

      {/* Right Panel */}
      <Grid item xs={false} md={6} sx={{
        background: 'linear-gradient(to right,rgb(11, 2, 114),rgb(7, 67, 197))',
        color: '#fff', display: 'flex', flexDirection: 'column',
        justifyContent: 'center', alignItems: 'center', textAlign: 'center', px: 6,
      }}>
        <Typography variant="h5" fontWeight="bold">
          Welcome to eBrary Guru!
        </Typography>
        <Typography variant="body1">
          Welcome to eBrary Guru—the ultimate destination for seamless learning and exploration! Access a vast library of over eBooks, eJournals, and research articles. Enroll in your courses, connect with specialized AI chatbots, and keep track of your progress—all in one unified platform. Dive into a world of knowledge where education is personalized, accessible, and empowering. Your journey towards excellence begins here.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PasswordPage;
